(function () {
  'use strict';
  if (window.__lotusPostHog) return;
  var configElement = document.getElementById('lotus-posthog-config');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  var allowedTypes = ['index', 'product', 'collection', 'list-collections', 'cart', 'page', 'blog', 'article', 'search', 'policy', '404'];
  if (allowedTypes.indexOf(config.page_type) < 0) return;
  window.__lotusPostHog = { state: 'waiting_for_consent' };
  var state = window.__lotusPostHog;
  function setState(value) { state.state = value; configElement.setAttribute('data-state', value); }
  setState('waiting_for_consent');
  var token = 'phc_rrUtdCukEqQrfLv7Xw4yrpTjewBpUYJMFP8L24J3LtYy';
  var cookieName = config.environment === 'preview' ? 'll_ph_preview_v1' : 'll_ph_anon_v1';
  var sdk = null;
  var loading = false;
  var pageCaptured = false;
  var allowed = false;
  var identity = null;
  var pendingErrors = [];
  var seenErrors = Object.create(null);
  var errorCount = 0;
  var errorTypes = ['Error', 'TypeError', 'ReferenceError', 'SyntaxError', 'RangeError', 'URIError', 'EvalError', 'AggregateError'];
  var safeKeys = ['distinct_id', '$device_id', '$session_id', '$window_id', '$lib', '$lib_version', '$browser', '$browser_version', '$device_type', '$os', '$os_version', '$screen_height', '$screen_width', '$viewport_height', '$viewport_width', 'environment', 'integration_version', 'source', 'page_type', 'product_id', 'variant_id', 'currency', '$current_url', '$pathname', '$host'];

  function permitted() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function cookie(value, maxAge) {
    var domain = /(^|\.)shoplotuslinen\.com$/.test(location.hostname) ? '; Domain=shoplotuslinen.com' : '';
    document.cookie = cookieName + '=' + value + '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax; Secure' + domain;
  }
  function anonymousId() {
    var match = document.cookie.split('; ').find(function (part) { return part.indexOf(cookieName + '=') === 0; });
    var value = match && match.slice(cookieName.length + 1);
    if (!value || !/^[0-9a-f-]{36}$/.test(value)) value = crypto.randomUUID();
    cookie(value, 2592000);
    return value;
  }
  function safePath() {
    if (config.page_type === 'search') return '/search';
    if (config.page_type === '404') return '/404';
    return location.pathname;
  }
  function safeErrorFrame(filename, line, column) {
    var safeName = '[external-or-unavailable]';
    if (filename === '[storefront-inline]') safeName = filename;
    else {
      try {
        var url = new URL(filename, location.origin);
        if (!url.username && !url.password && url.origin === location.origin) {
          if (/^\/cdn\/shop\/t\/\d+\/assets\/[A-Za-z0-9._-]+\.js$/.test(url.pathname)) safeName = url.origin + url.pathname;
          else if (url.pathname === location.pathname) safeName = '[storefront-inline]';
        }
      } catch (_) {}
    }
    var integer = function (value) { return Number.isInteger(value) && value > 0 && value < 10000000 ? value : undefined; };
    return { platform: 'custom', lang: 'javascript', 'function': '[redacted]', filename: safeName, lineno: integer(line), colno: integer(column), in_app: safeName !== '[external-or-unavailable]', resolved: true };
  }
  function safeException(properties) {
    if (properties.lotus_error_schema !== 1 || ['uncaught_error', 'unhandled_rejection'].indexOf(properties.error_kind) < 0) return null;
    var exception = properties.$exception_list && properties.$exception_list[0];
    if (!exception) return null;
    var frame = exception.stacktrace && exception.stacktrace.frames && exception.stacktrace.frames[0] || {};
    var cleanFrame = safeErrorFrame(frame.filename, frame.lineno, frame.colno);
    var type = errorTypes.indexOf(exception.type) >= 0 ? exception.type : 'Error';
    return {
      list: [{ type: type, value: properties.error_kind === 'uncaught_error' ? 'Uncaught storefront error; message omitted for privacy' : 'Unhandled storefront promise rejection; message omitted for privacy', mechanism: { handled: false, synthetic: false }, stacktrace: { type: 'raw', frames: [cleanFrame] } }],
      fingerprint: ['lotus-error-v1', properties.error_kind, type, cleanFrame.filename, cleanFrame.lineno || 0, cleanFrame.colno || 0].join(':')
    };
  }
  function flushErrors() {
    if (!sdk || !permitted()) return;
    pendingErrors.splice(0).forEach(function (properties) { try { sdk.capture('$exception', properties); } catch (_) {} });
  }
  function captureBrowserError(kind, error, filename, line, column) {
    if (!permitted() || errorCount >= 5) return;
    try {
      var frame = safeErrorFrame(filename, line, column);
      if (frame.filename === '[external-or-unavailable]' && error && typeof error.stack === 'string') {
        var pattern = /(https:\/\/[^\s)]+):(\d+):(\d+)/g;
        var stack = error.stack.slice(0, 8192), match, attempts = 0;
        while ((match = pattern.exec(stack)) && attempts++ < 10) {
          var candidate = safeErrorFrame(match[1], Number(match[2]), Number(match[3]));
          if (candidate.in_app) { frame = candidate; break; }
        }
      }
      var type = error && errorTypes.indexOf(error.name) >= 0 ? error.name : 'Error';
      var properties = { environment: config.environment, integration_version: 'lotus-1', source: 'theme_error', page_type: config.page_type, lotus_error_schema: 1, error_kind: kind, $exception_list: [{ type: type, stacktrace: { frames: [frame] } }] };
      var clean = safeException(properties);
      if (!clean || seenErrors[clean.fingerprint]) return;
      seenErrors[clean.fingerprint] = true;
      errorCount += 1;
      pendingErrors.push(properties);
      flushErrors();
    } catch (_) {}
  }
  window.addEventListener('error', function (event) {
    if (typeof event.message === 'string') captureBrowserError('uncaught_error', event.error, event.filename, event.lineno, event.colno);
  });
  window.addEventListener('unhandledrejection', function (event) {
    captureBrowserError('unhandled_rejection', event.reason);
  });
  var allowedEvents = ['$pageview', '$pageleave', 'product_viewed', 'cart_viewed', '$exception', '$autocapture', '$rageclick', '$dead_click', '$snapshot', '$web_vitals',
    'embroidery_opened', 'embroidery_closed', 'embroidery_font_selected', 'embroidery_name_entered'];
  var keepQuery = /^(utm_[a-z]+|gclid|gbraid|wbraid|fbclid|msclkid)$/;
  function safeUrl(raw) {
    try {
      var url = new URL(raw, location.origin);
      if (config.page_type === 'search') return url.origin + '/search';
      if (config.page_type === '404') return url.origin + '/404';
      var params = new URLSearchParams();
      url.searchParams.forEach(function (v, k) { if (keepQuery.test(k)) params.append(k, v); });
      var q = params.toString();
      return url.origin + url.pathname + (q ? '?' + q : '');
    } catch (_) { return location.origin + safePath(); }
  }
  function beforeSend(event) {
    if (!event || !permitted()) return null;
    var name = event.event;
    if (allowedEvents.indexOf(name) < 0 && name.indexOf('$$') !== 0) return null;
    var properties = event.properties || {};
    if (name === '$snapshot') {
      // recordings: strip query strings from EVERY stored URL (the embroidery app puts the typed name in the URL, e.g. ?personalized=...)
      var scrub = function (obj, depth) {
        if (!obj || typeof obj !== 'object' || depth > 6) return;
        Object.keys(obj).forEach(function (k) {
          var v = obj[k];
          if (typeof v === 'string' && v.indexOf('?') > -1 && /^https?:\/\//.test(v) && v.indexOf(location.hostname) > -1) obj[k] = safeUrl(v);
          else if (v && typeof v === 'object') scrub(v, depth + 1);
        });
      };
      try { scrub(properties, 0); } catch (_) {}
    }
    if (name === '$exception') {
      var exception = safeException(properties);
      if (!exception) return null;
      var clean = {};
      safeKeys.forEach(function (key) { if (properties[key] !== undefined) clean[key] = properties[key]; });
      clean.environment = config.environment; clean.source = 'theme_error'; clean.page_type = config.page_type;
      clean.lotus_error_schema = 1; clean.error_kind = properties.error_kind;
      clean.$exception_list = exception.list; clean.$exception_fingerprint = exception.fingerprint; clean.$exception_level = 'error';
      properties = clean;
    }
    ['$ip', '$set', '$set_once', '$geoip_city_name', '$geoip_postal_code', '$geoip_latitude', '$geoip_longitude'].forEach(function (k) { delete properties[k]; });
    properties.token = token;
    if (properties.$current_url) properties.$current_url = safeUrl(properties.$current_url);
    if (properties.$referrer && properties.$referrer !== '$direct') { try { var r = new URL(properties.$referrer); properties.$referrer = r.origin + r.pathname; } catch (_) {} }
    properties.$pathname = safePath();
    properties.$host = location.hostname;
    properties.$process_person_profile = false;
    properties.$is_identified = false;
    properties.$geoip_disable = true;
    properties.environment = config.environment;
    properties.page_type = config.page_type;
    event.properties = properties;
    return event;
  }
  // embroidery funnel (never sends the typed name, only its length)
  function track(name, props) {
    if (!sdk || !permitted()) return;
    try { sdk.capture(name, Object.assign({ product_id: config.product_id ? String(config.product_id) : null, integration_version: 'lotus-2' }, props || {})); } catch (_) {}
  }
  function watchEmbroidery() {
    if (config.page_type !== 'product' || !window.MutationObserver) return;
    var open = false;
    new MutationObserver(function () {
      var now = !!document.querySelector('.embroidery__modal');
      if (now !== open) { open = now; track(now ? 'embroidery_opened' : 'embroidery_closed'); }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var f = e.target && e.target.closest && e.target.closest('.font-option');
      if (f) track('embroidery_font_selected', { font: (f.innerText || f.getAttribute('data-font') || '').trim().slice(0, 30) || null });
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.embroidery__input')) track('embroidery_name_entered', { name_length: (e.target.value || '').length });
    }, true);
  }
  function capturePage() {
    if (!sdk || !permitted() || pageCaptured) return;
    pageCaptured = true;
    var properties = { environment: config.environment, integration_version: 'lotus-1', source: 'theme', page_type: config.page_type };
    sdk.capture('$pageview', properties);
    if (config.page_type === 'product' && config.product_id) {
      sdk.capture('product_viewed', Object.assign({}, properties, { product_id: String(config.product_id), variant_id: config.variant_id ? String(config.variant_id) : null, currency: config.currency }));
    }
    if (config.page_type === 'cart') sdk.capture('cart_viewed', properties);
    setState('ready');
  }
  function initSdk() {
    if (!permitted()) { loading = false; return; }
    identity = anonymousId();
    window.posthog.init(token, {
      api_host: 'https://us.i.posthog.com', ui_host: 'https://us.posthog.com',
      defaults: '2026-08-30',
      // v2 2026-10-30: first-party persistence so one visit = one session across pages (was 'memory')
      persistence: 'localStorage+cookie', cross_subdomain_cookie: true, secure_cookie: true,
      request_batching: true,
      bootstrap: { distinctID: identity, isIdentifiedID: false },
      person_profiles: 'never',
      autocapture: { dom_event_allowlist: ['click', 'submit', 'change'], element_allowlist: ['a', 'button', 'form', 'input', 'select', 'textarea', 'label'] },
      capture_pageview: false, capture_pageleave: true,
      // privacy-safe recordings: every input masked, embroidery modal text masked, canvas never recorded
      disable_session_recording: false,
      session_recording: { maskAllInputs: true, maskTextSelector: '.embroidery__modal, [data-ph-mask]', recordCrossOriginIframes: false },
      capture_heatmaps: true, capture_dead_clicks: true, rageclick: true,
      capture_performance: { web_vitals: true, network_timing: false },
      capture_exceptions: false, capture_webmcp: false,
      disable_surveys: true, disable_product_tours: true, disable_conversations: true,
      disable_web_experiments: true, disable_external_dependency_loading: false,
      advanced_disable_flags: false, // needed so PostHog can tell the SDK that recordings are on (no flags are used) save_referrer: true, save_campaign_params: true,
      disable_scroll_properties: false, ip: false, before_send: beforeSend,
      mask_personal_data_properties: true, custom_personal_data_properties: ['personalized', 'embvariant', 'font', 'color', 'type'],
      loaded: function (instance) {
        sdk = instance;
        loading = false;
        if (permitted()) { sdk.opt_in_capturing({ captureEventName: false }); capturePage(); flushErrors(); watchEmbroidery(); }
        else sdk.opt_out_capturing();
      }
    });
  }
  function start() {
    if (sdk) {
      sdk.opt_in_capturing({ captureEventName: false });
      capturePage();
      return;
    }
    if (loading) return;
    if (window.posthog && (window.posthog.__loaded || window.posthog.__SV)) {
      setState('existing_sdk_detected');
      return;
    }
    loading = true;
    var stub = window.posthog = [];
    stub._i = [];
    stub.__SV = 1;
    stub.init = function (key, options) { stub._i.push([key, options, 'posthog']); };
    ['capture', 'opt_in_capturing', 'opt_out_capturing', 'reset'].forEach(function (method) {
      stub[method] = function () { stub.push([method].concat(Array.prototype.slice.call(arguments))); };
    });
    var script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.onerror = function () { setState('sdk_load_failed'); loading = false; };
    initSdk();
    document.head.appendChild(script);
  }
  function updateConsent() {
    var next = permitted();
    if (!next) {
      pendingErrors.length = 0;
      allowed = false;
      cookie('', 0);
      if (sdk) sdk.opt_out_capturing();
      identity = null;
      setState('consent_denied');
      return;
    }
    if (!allowed && sdk) {
      identity = anonymousId();
      sdk.reset();
      sdk.register({ distinct_id: identity, $device_id: identity });
    }
    allowed = true;
    start();
  }
  document.addEventListener('visitorConsentCollected', updateConsent);
  var tries = 0;
  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) { updateConsent(); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) updateConsent(); else setState('privacy_api_unavailable');
      });
      return;
    }
    if (++tries < 40) setTimeout(loadPrivacy, 250);
    else setState('privacy_api_unavailable');
  }
  loadPrivacy();
})();
